<script setup lang="ts">
import { onMounted } from 'vue';

import { useStatsigEventsStore } from '@apps/main/new-desktop/core/stores';

import { UnavailabilityReason, ItinerarySegmentType } from '../../../models';
import UnavailableProductLayout from '../UnavailableProductLayout.vue';
import UnavailableProductAction from '../UnavailableProductAction.vue';

interface UnavailableFerryProductProps {
  reasons: UnavailabilityReason[];
  message: string;
}
const props = defineProps<UnavailableFerryProductProps>();

interface UnavailableFerryProductEmits {
  (event: 'try-another-date'): void;
  (event: 'edit-filters'): void;
}
const emit = defineEmits<UnavailableFerryProductEmits>();

const statsigEventsStore = useStatsigEventsStore();

onMounted(() => {
  statsigEventsStore.logTripOverviewUnavailableProductRendered({
    productType: 'ferry',
    isSelectedProduct: props.reasons.includes(
      UnavailabilityReason.SelectedProduct
    )
      ? 'true'
      : 'false',
    hasSelectedFilters: props.reasons.includes(
      UnavailabilityReason.SelectedFilters
    )
      ? 'true'
      : 'false',
  });
});
</script>

<template>
  <UnavailableProductLayout>
    <template #message>
      <div>{{ props.message }}</div>
    </template>
    <template #actions>
      <template v-for="(reason, index) in props.reasons" :key="index">
        <span v-if="index > 0">&nbsp;{{ $t('planner.or') }}&nbsp;</span>
        <UnavailableProductAction
          :product-action="{
            reason,
            segmentType: ItinerarySegmentType.Ferry,
          }"
          @edit-filters="emit('edit-filters')"
          @try-another-date="emit('try-another-date')"
        />
      </template>
    </template>
  </UnavailableProductLayout>
</template>
